import { MockDebug } from '@tino-frontend/mocks'

import { checkUnicoResponseMock } from '@fixtures/apis/user/check-unico-response'
import { CheckUnicoResultResponseApprovedMock } from '@fixtures/apis/user/check-unico-result-response-approved'
import { CheckUnicoResultResponseFailedMock } from '@fixtures/apis/user/check-unico-result-response-failed'
import { CheckUnicoResultResponseNotProcessedMock } from '@fixtures/apis/user/check-unico-result-response-not-processed'
import { CheckUnicoResultResponseRejectMock } from '@fixtures/apis/user/check-unico-result-response-reject'
import {
  REACT_APP_AUTH_API_URL,
  REACT_APP_CORE_API_URL,
  REACT_APP_MERCHANT_BFF_API_URL,
} from 'constants/envs'
import { CheckUnicoResultResponseLivenessReprovedMock } from '@fixtures/apis/user/check-unico-result-response-liveness-reproved'
import { meAPIMock } from '@fixtures/apis/me'
import { situationAPIMock } from '@fixtures/apis/situation'
import { legalPersonAPIMock } from '@fixtures/apis/legal-person'

// Service: Me Situation
const MockDebugSituation: MockDebug = {
  title: 'Status do Usuário (Situation)',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/me/situation`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-situation-status-onboarded',
      title: 'onboarded',
      status: 200,
      data: situationAPIMock.build(
        {
          status: 'onboarded',
          legal_person_situation: [
            legalPersonAPIMock.build({
              ...legalPersonAPIMock.source,
              status: 'onboarded',
            }),
          ],
        },
        { mergeArray: false }
      ),
    },
    {
      id: 'mock-situation-status-rejected',
      title: 'rejected',
      status: 200,
      data: situationAPIMock.build({
        status: 'rejected',
      }),
    },
    {
      id: 'mock-situation-status-verified',
      title: 'verified',
      status: 200,
      data: situationAPIMock.build({
        status: 'verified',
      }),
    },
    {
      id: 'mock-situation-status-waiting-whatsapp',
      title: 'Waiting WhatsApp',
      status: 200,
      data: situationAPIMock.build({
        status: 'waiting_whatsapp',
      }),
    },
    {
      id: 'mock-situation-status-waiting-docs-unico',
      title: 'Waiting Docs with UNICO',
      status: 200,
      data: situationAPIMock.build({
        status: 'waiting_docs',
        kyc_mode: 'IDUnico',
      }),
    },
    {
      id: 'mock-situation-status-waiting-docs-quiz',
      title: 'Waiting Docs with QUIZ',
      status: 200,
      data: situationAPIMock.build({
        status: 'waiting_docs',
        kyc_mode: 'quiz',
      }),
    },
  ],
}

const MockUserTerms: MockDebug = {
  title: 'Termos para Cadastro',
  path: `${REACT_APP_CORE_API_URL}/terms/sign-up`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-terms-success',
      title: 'Com termos pendentes',
      status: 200,
      data: {
        terms: [
          {
            content: 'Termo de adesão',
            id: 'mocked-agreement-term-id',
            type: 'agreement',
          },
          {
            content: 'Termo de consentimento',
            id: 'mocked-consent-term-id',
            type: 'consent',
          },
          {
            content: 'Termo de politica de privacidade',
            id: 'mocked-privacy-policy-term-id',
            type: 'privacy_policy',
          },
        ],
      },
    },
    {
      id: 'mock-empty-terms-success',
      title: 'Sem termos',
      status: 200,
      data: {
        terms: [],
      },
    },
    {
      id: 'mock-terms-bad-request',
      title: '[Erro] Bad Request',
      status: 400,
      data: {
        message: 'Bad Request',
      },
    },
    {
      id: 'mock-terms-internal-server-error',
      title: '[Erro] Internal Server Error',
      status: 500,
      data: {
        message: 'Internal Server Error',
      },
    },
  ],
}

// Service: User
const MockDebugMe: MockDebug = {
  title: 'Informações do Usuário (Me)',
  path: `${REACT_APP_CORE_API_URL}/me`,
  method: 'get',
  delay: 0,
  options: [
    {
      id: 'mock-me-success',
      title: 'celtino',
      status: 200,
      data: meAPIMock.build(),
    },
  ],
}

// Service: Unico Check
const mockDebugUnicoCheck: MockDebug = {
  title: 'Unico Check',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/checks`,
  method: 'post',
  delay: 2000,
  options: [
    {
      id: 'mock-unico-check-success',
      title: 'Success',
      status: 200,
      data: checkUnicoResponseMock.source,
    },
    {
      id: 'mock-unico-check-error',
      title: 'Error',
      status: 500,
      data: { message: 'error X' },
    },
  ],
}

// Service: Unico Check
const mockDebugUnicoCheckResult: MockDebug = {
  title: 'Unico Check Result',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/checks/:id`,
  method: 'get',
  delay: 5000,
  options: [
    {
      id: 'mock-unico-check-result-approved',
      title: 'approved',
      status: 200,
      data: CheckUnicoResultResponseApprovedMock.source,
    },
    {
      id: 'mock-unico-check-result-failed',
      title: 'failed',
      status: 200,
      data: CheckUnicoResultResponseFailedMock.source,
    },
    {
      id: 'mock-unico-check-result-not-processed',
      title: 'not processed',
      status: 200,
      data: CheckUnicoResultResponseNotProcessedMock.source,
    },
    {
      id: 'mock-unico-check-result-reject',
      title: 'reject',
      status: 200,
      data: CheckUnicoResultResponseRejectMock.source,
    },
    {
      id: 'mock-unico-check-result-live-reproved',
      title: 'live reproved',
      status: 200,
      data: CheckUnicoResultResponseLivenessReprovedMock.source,
    },
    {
      id: 'mock-unico-check-result-error-500',
      title: 'Error 500',
      status: 500,
      data: { message: 'error X' },
    },
  ],
}

// Service: User
const mockDebugPhoneVerified: MockDebug = {
  title: 'Verify Authenticated Phone',
  path: `${REACT_APP_AUTH_API_URL}/v1/phones/verified`,
  method: 'get',
  delay: 2000,
  options: [
    {
      id: 'mock-user-phone-verified',
      title: 'Verificado',
      status: 200,
      data: { verified: true },
    },
    {
      id: 'mock-user-phone-not-verified',
      title: 'Não verificado',
      status: 200,
      data: { verified: false },
    },
  ],
}

// Service: User
const mockSignUpOTP: MockDebug = {
  title: 'WhatsApp OTP (Sign Up)',
  path: `${REACT_APP_AUTH_API_URL}/v1/sign-up/whatsapp/otp`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-otp-valid',
      title: 'OTP válido',
      status: 200,
      data: {},
    },
    {
      id: 'mock-otp-invalid',
      title: 'Telefone com conflito',
      status: 409,
      data: {
        error_id: 'auth/phone_already_exists',
        data: 'd***l@tino.com.br',
      },
    },
  ],
}

// Service: User
const mockVerifySignUpOTP: MockDebug = {
  title: 'WhatsApp OTP Verify (Sign Up)',
  path: `${REACT_APP_AUTH_API_URL}/v1/sign-up/whatsapp/otp/verify`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-otp-valid',
      title: 'OTP válido',
      status: 200,
      data: {},
    },
    {
      id: 'mock-otp-invalid',
      title: 'OTP inválido',
      status: 500,
      data: { code: 2, details: [], message: 'submitted otp is incorrect' },
    },
  ],
}

// Service: User
const mockVerifySignInOTP: MockDebug = {
  title: 'WhatsApp OTP Verify (Sign In)',
  path: `${REACT_APP_AUTH_API_URL}/v1/sign-in/whatsapp/otp/verify`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-otp-valid',
      title: 'OTP válido',
      status: 200,
      data: {},
    },
    {
      id: 'mock-otp-invalid',
      title: 'OTP inválido',
      status: 500,
      data: { code: 2, details: [], message: 'submitted otp is incorrect' },
    },
  ],
}

export const MockDebugUser = [
  MockDebugMe,
  MockDebugSituation,
  MockUserTerms,
  mockDebugUnicoCheck,
  mockDebugUnicoCheckResult,
  mockDebugPhoneVerified,
  mockSignUpOTP,
  mockVerifySignUpOTP,
  mockVerifySignInOTP,
]
